import { render, staticRenderFns } from "./MenuManager.vue?vue&type=template&id=64354e26&scoped=true&"
import script from "./MenuManager.vue?vue&type=script&lang=js&"
export * from "./MenuManager.vue?vue&type=script&lang=js&"
import style0 from "./MenuManager.vue?vue&type=style&index=0&id=64354e26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64354e26",
  null
  
)

/* custom blocks */
import block0 from "./MenuManager.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports